import Cookies from 'js-cookie';
import { CookieNames, CookieStateValues } from '../config/constants';

export default (state: boolean) => {
    Cookies.set(
        CookieNames.PP_STATE,
        state
            ? CookieStateValues.accepted
            : CookieStateValues.rejected,
    );
    Cookies.set(CookieNames.PP_DATE, Date.now().toString());
};
